<template>
  <div class="dashboard">
    <!-- v-if="this.$store.state.user.user" -->
    <v-container>
      <v-row>
        <v-col cols="12" md="4" v-for="item in validItemsMenu" :key="item.text">
          <v-card class="mx-auto" outlined>
            <v-list-item class="pa-5">
              <v-list-item-avatar>
                <v-icon class="secondary lighten-1" dark>
                  {{ item.icon }}
                </v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="text-left headline mb-1">
                  {{ item.text }}
                </v-list-item-title>
              </v-list-item-content>


                <span class="primary--text headline font-weight-bold">{{
                  item.total
                }}</span>

            </v-list-item>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text right color="secondary" :to="item.to">
                ver más
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { SET_DASHBOARD } from "@/store/dashboard";
export default {
  name: "Dashboard",
  data: () => ({
    dashboard: {},
    items: [
      {
        text: "Colaboradores",
        to: "/employees",
        icon: "mdi-account-group",
        roles: ["ADMINISTRATOR"],
        total: 0,
      },
      {
        text: "Contratos",
        to: "/contracts",
        icon: "mdi-file-document-multiple-outline",
        roles: ["ADMINISTRATOR","EMPLOYEE"],
        total: 0,
      },
      {
        text: "Informes",
        to: "/reports",
        icon: "mdi-file-chart",
        roles: ["ADMINISTRATOR","EMPLOYEE","REVIEWER"],
        total: 0,
      },
      {
        text: "Cuentas de cobro",
        to: "/bills",
        icon: "mdi-text-box-outline",
        roles: ["ADMINISTRATOR","EMPLOYEE"],
        total: 0,
      },
      {
        text: "Cargos",
        to: "/charges",
        icon: "mdi-card-account-details",
        roles: ["ADMINISTRATOR"],
        total: 0,
      },
      {
        text: "Usuarios",
        to: "/users",
        icon: "mdi-account-multiple-outline",
        roles: ["ADMINISTRATOR"],
        total: 0,
      },
    ],
  }),
  created() {
    this.$store.dispatch("getDashboard");
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === SET_DASHBOARD) {
        this.dashboard = state.dashboard.dashboard;
        this.items[0].total = this.dashboard.total_employees;
        this.items[1].total = this.dashboard.total_contracts;
        this.items[2].total = this.dashboard.total_reports;
        this.items[3].total = this.dashboard.total_bills;
        this.items[4].total = this.dashboard.total_charges;
        this.items[5].total = this.dashboard.total_users;
      }
    });
  },
  computed: {
    role() {
      return this.$store.state.user.user != null
        ? this.$store.state.user.user.role
        : "";
    },
    validItemsMenu() {
      var validItems = [];
      this.items.forEach((item) => {
        if (this.validateRole(item.roles)) {
          validItems.push(item);
        }
      });
      return validItems;
    },
  },
  methods: {
    validateRole(roles) {
      if (roles.indexOf("*") >= 0) {
        return true;
      }

      if (roles.indexOf(this.role) >= 0) {
        return true;
      }

      return false;
    },
  },
};
</script>
